import { 
  COLOR_WARM_GREY,
  createSliceLayout,
  SliceBlockThumbnailGrid,
} from '@shapeable/ui';
import { ProductGrid } from '../entities/product-grid';
import { SliceProductBenefits } from '../entities/slice-product-benefit';
import { SliceProductIndustries } from '../entities/slice-product-industries';

export const SliceLayoutBenefits = createSliceLayout(
  SliceProductBenefits, {
    verticalPadding: 'large',
  }
);

export const SliceLayoutProductIndustries = createSliceLayout(
  SliceProductIndustries, {
    verticalPadding: 'small',
    boundary: 'content',
    defaultBackgroundColor: COLOR_WARM_GREY,
  }
);

export const SliceLayoutProductGrid = createSliceLayout(
  ProductGrid, {
    verticalPadding: 'small',
    boundary: 'content-bleed',
  },
);

export const SliceLayoutBlockThumbnailCardGrid3Columns = createSliceLayout(
  SliceBlockThumbnailGrid, {
    verticalPadding: 'none',
    boundary: 'none',
    props: {
      variant: 'card',
      columns: 0,
      spacing: 0.5,
      tabletMinColumns: 2,
      desktopAutoColumns: 3,
      desktopMinColumns: 3,
      desktopFullHdMinColumns: 3,
      desktopLargeMinColumns: 3,
      desktopLargeAutoColumns: 3,
      desktopFullHdAutoColumns: 3
    }
  }
);